import { Link } from "react-router-dom";
import { Mail, Phone, Facebook, Music2, MessageCircle } from "lucide-react";
import { LogoMark } from "./Logo";
import { useLang } from "../LanguageContext";
import { CONTACT, IMAGES, waLink } from "../data/site";

export const Footer = () => {
  const year = new Date().getFullYear();
  const { s } = useLang();
  return (
    <footer data-testid="site-footer" className="relative border-t border-white/[0.07] bg-black/40">
      <div className="mx-auto grid w-full max-w-6xl gap-12 px-5 py-16 sm:px-8 md:grid-cols-[1.4fr_1fr_1fr]">
        <div>
          <div className="flex items-start justify-between gap-6">
            <div className="flex items-center gap-3">
              <LogoMark className="h-10 w-10" />
              <span className="font-serif text-2xl text-white">
                Porte <span className="italic text-gold-light">de</span> Lumière
              </span>
            </div>
            <div data-testid="footer-certification-badge" className="shrink-0 rounded-full bg-white p-1 shadow-[0_8px_24px_rgba(0,0,0,0.4)]">
              <img src={IMAGES.badge} alt={s.about.badgeAlt} className="h-12 w-12 rounded-full" />
            </div>
          </div>
          <p className="mt-4 max-w-sm text-sm leading-relaxed text-white/55">{s.footer.tagline}</p>
          <p className="mt-5 font-mono text-[11px] uppercase tracking-[0.25em] text-gold/70">{s.footer.signature}</p>
        </div>

        <div>
          <h3 className="eyebrow">{s.footer.navTitle}</h3>
          <ul className="mt-5 space-y-3 text-sm text-white/60">
            <li><Link to="/" data-testid="footer-link-home" className="transition-colors hover:text-gold-light">{s.footer.links.home}</Link></li>
            <li><Link to="/accompagnements" data-testid="footer-link-offers" className="transition-colors hover:text-gold-light">{s.footer.links.offers}</Link></li>
            <li><Link to="/contact" data-testid="footer-link-contact" className="transition-colors hover:text-gold-light">{s.footer.links.contact}</Link></li>
          </ul>
        </div>

        <div>
          <h3 className="eyebrow">{s.footer.contactTitle}</h3>
          <ul className="mt-5 space-y-3 text-sm text-white/60">
            <li>
              <a href={`mailto:${CONTACT.email}`} data-testid="footer-email-link" className="flex items-center gap-2.5 transition-colors hover:text-gold-light">
                <Mail className="h-4 w-4 text-gold/70" /> {CONTACT.email}
              </a>
            </li>
            <li>
              <a href={waLink(s.wa.defaultMsg)} target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp-link" className="flex items-center gap-2.5 transition-colors hover:text-mint">
                <MessageCircle className="h-4 w-4 text-mint/80" /> {s.footer.whatsapp} {CONTACT.phoneDisplay}
              </a>
            </li>
            <li>
              <a href={`tel:${CONTACT.phoneRaw}`} data-testid="footer-phone-link" className="flex items-center gap-2.5 transition-colors hover:text-gold-light">
                <Phone className="h-4 w-4 text-gold/70" /> {s.footer.phone} — {CONTACT.phoneDisplay}
              </a>
            </li>
            <li>
              <a href={CONTACT.facebookHub} target="_blank" rel="noopener noreferrer" data-testid="footer-facebook-link" className="flex items-center gap-2.5 transition-colors hover:text-sky2">
                <Facebook className="h-4 w-4 text-sky2/80" /> {s.footer.facebook}
              </a>
            </li>
            <li>
              <a href={CONTACT.tiktok} target="_blank" rel="noopener noreferrer" data-testid="footer-tiktok-link" className="flex items-center gap-2.5 transition-colors hover:text-iris">
                <Music2 className="h-4 w-4 text-iris/90" /> {s.footer.tiktok}
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/[0.06]">
        <p className="mx-auto w-full max-w-6xl px-5 py-6 text-[11px] leading-relaxed text-white/35 sm:px-8">
          {s.acc.disclaimer}
        </p>
        <p className="pb-8 text-center text-xs text-white/40">
          © {year} Porte de Lumière — François Gautier MAKARGA. {s.footer.rights}
        </p>
      </div>
    </footer>
  );
};
